import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@campus/browser';
import { Observable } from 'rxjs';
import { ScormApiInterface, ScormCmiMode } from './scorm-api.interface';
import { ScormApiServiceInterface } from './scorm-api.service.interface';
import { SCORM_API } from './scorm-api.token';

@Injectable({
  providedIn: 'root',
})
export class ScormApiService implements ScormApiServiceInterface {
  commit$: Observable<string>;
  cmi$: Observable<string>;

  public get hasFinished() {
    return this.API.hasCalledLMSFinish;
  }

  private API: ScormApiInterface;
  private window = inject(WINDOW);

  constructor() {
    this.window.API ??= inject(SCORM_API);
    this.API = this.window.API;
    this.commit$ = this.API.commit$;
    this.cmi$ = this.API.cmi$;
  }

  init(cmi: string, mode: ScormCmiMode, eduContentId?: number) {
    this.API.mode = mode;
    this.API.eduContentId = eduContentId;
    this.API.setCurrentCMI(cmi);
  }
}
